import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["className"],
  _excluded2 = ["className", "description", "showCustomerServiceInfo"],
  _excluded3 = ["className"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { MailOutlined, TabletOutlined } from '@ant-design/icons';
import { notification } from 'antd';
import classNames from 'classnames';
import { DixuCol, DixuRow } from "../DixuGrid/DixuGrid";
import DixuLink from "../DixuLink/DixuLink";
import DixuText from "../DixuText/DixuText";
import React from 'react';
import { DIXU_CONTACT_INFO } from "../../utils/DixuConstants";
const commonDefaults = {
  placement: 'topLeft',
  duration: 5
};
const commonClassNames = ['dixu-notification', 'box-shadow-1', 'border-radius-md'];
const success = _ref => {
  let {
      className
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return notification.success(_objectSpread(_objectSpread({
    className: classNames(commonClassNames, 'dixu-notification--success', className)
  }, commonDefaults), rest));
};
const error = _ref2 => {
  let {
      className,
      description,
      showCustomerServiceInfo = true
    } = _ref2,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  return notification.error(_objectSpread(_objectSpread({
    className: classNames(commonClassNames, 'dixu-notification--error', className),
    description: (() => {
      if (!showCustomerServiceInfo) {
        return description;
      }
      return /*#__PURE__*/React.createElement(DixuRow, {
        gutter: [0, 16]
      }, description && /*#__PURE__*/React.createElement(DixuCol, {
        span: 24
      }, description), /*#__PURE__*/React.createElement(DixuCol, {
        span: 24
      }, /*#__PURE__*/React.createElement(DixuRow, {
        gutter: [0, 4]
      }, /*#__PURE__*/React.createElement(DixuCol, {
        span: 24
      }, "Ole tarvittaessa yhteydess\xE4 asiakaspalveluumme:"), /*#__PURE__*/React.createElement(DixuCol, {
        span: 24
      }, /*#__PURE__*/React.createElement(DixuRow, null, /*#__PURE__*/React.createElement(DixuCol, {
        span: 24
      }, /*#__PURE__*/React.createElement(DixuLink, {
        href: `mailto:${DIXU_CONTACT_INFO.email}`
      }, /*#__PURE__*/React.createElement(DixuRow, {
        align: "middle",
        gutter: 8,
        wrap: false,
        type: "inline"
      }, /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuText, {
        font: "3"
      }, /*#__PURE__*/React.createElement(MailOutlined, null))), /*#__PURE__*/React.createElement(DixuCol, null, DIXU_CONTACT_INFO.email)))), /*#__PURE__*/React.createElement(DixuCol, {
        span: 24
      }, /*#__PURE__*/React.createElement(DixuLink, {
        href: `tel:${DIXU_CONTACT_INFO.tel}`
      }, /*#__PURE__*/React.createElement(DixuRow, {
        align: "middle",
        gutter: 8,
        wrap: false,
        type: "inline"
      }, /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuText, {
        font: "3"
      }, /*#__PURE__*/React.createElement(TabletOutlined, null))), /*#__PURE__*/React.createElement(DixuCol, null, DIXU_CONTACT_INFO.tel)))))))));
    })()
  }, commonDefaults), {}, {
    duration: 0
  }, rest));
};
const open = _ref3 => {
  let {
      className
    } = _ref3,
    rest = _objectWithoutProperties(_ref3, _excluded3);
  return notification.open(_objectSpread(_objectSpread({
    className: classNames(commonClassNames, 'dixu-notification--open', className)
  }, commonDefaults), rest));
};
const DixuNotification = {
  success,
  error,
  open
};
export default DixuNotification;